/**
 * 农户路由
 */
const LandlordRouter = {
  path: 'landlord',
  name: 'Landlord',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/Landlord/index')
}
export default LandlordRouter
